import { IDatasource, IDatasourceReportFn } from 'core-ts-types';
import { IStaffDrivenData } from '../staff_todo_interface';
import * as _4 from 'lodash4';

export class StaffTodoListDatastore implements IDatasource {
  private _source: IStaffDrivenData[];

  constructor() {
    this.initialize();
  }

  initialize(): StaffTodoListDatastore {
    this._source = [];
    return this;
  }

  write(staffTodoList: IStaffDrivenData[]): StaffTodoListDatastore {
    this._source = staffTodoList;
    return this;
  }

  read(): IStaffDrivenData[] {
    return this._source;
  }

  clear(): void {
    this.initialize();
  }

  isEmpty(): boolean {
    return _4.isEmpty(this._source);
  }

  report(fn: IDatasourceReportFn): any[] {
    return fn(this._source);
  }

  updateStaffTodo(staffTodo: IStaffDrivenData): void {
    const outdated = _4.remove(this._source, (current: IStaffDrivenData) => {
      return staffTodo.id === current.id;
    });
    if (!_4.isEmpty(outdated)) {
      this._source.push(staffTodo);
    }
  }
}

angular.module('data-ng-staff-todos').service('staffTodoListDatastore', StaffTodoListDatastore);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-staff-todos/src/datasources/staff_todo_list_datastore.ts